import { Modal, Button, Form } from "react-bootstrap";
import { useState } from "react";
import http from "../lib/http";

export default function LeadCaptureModal({
  show,
  onClose,
  dealer,
  category,
  onSuccess
}) {

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const validatePhone = (num) => {
    return /^[6-9]\d{9}$/.test(num);
  };

  const submitLead = async () => {

    if (!name || !phone) {
      alert("Please enter name and phone number");
      return;
    }

    if (!validatePhone(phone)) {
      alert("Enter valid 10 digit mobile number");
      return;
    }

    try {

      setLoading(true);

      await http.post("/api/leads", {
      customerName: name,
      customerPhone: phone,

      dealerId: dealer._id,
      dealerName: dealer.name,

      category,

      enquiryMessage: `Customer requested contact from ${dealer.name}`
    });

      setName("");
      setPhone("");

      onSuccess({
        customerName: name,
        customerPhone: phone,
        dealerName: dealer.name
      });

    } catch (err) {

      console.error("Lead capture failed", err);
      alert("Something went wrong. Try again.");

    } finally {

      setLoading(false);

    }

  };

  return (
    <Modal show={show} onHide={onClose} centered>

      <Modal.Header closeButton>
        <Modal.Title>Get Dealer Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <p className="small text-muted mb-3">
          Enter your details to view full dealer information
        </p>

        <Form.Group className="mb-3">
          <Form.Control
            placeholder="Your Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Form.Group>

        <Form.Group>
          <Form.Control
            placeholder="Phone Number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mt-3">
        <Form.Control
          as="textarea"
          rows={3}
          placeholder="Requirement (Optional)"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </Form.Group>
      </Modal.Body>

      <Modal.Footer>

        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>

        <Button variant="primary" onClick={submitLead} disabled={loading}>
          {loading ? "Please wait..." : "Continue"}
        </Button>

      </Modal.Footer>

    </Modal>
  );
}